import React from 'react'
import { Form, FormCheck } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import useDebounce from '../../../hooks/useDebounce'
import useSlug from '../../../hooks/useSlug'
import { currentUserSelector } from '../../auth/authSlice'
import colors from '../../../constants/colors'
import StyledIcon from '../../../components/Icon'
import { _ } from '../../../utils/localization'
import GeneralInfoWithThumbnail from '../../../components/GeneralInfoWithThumbnail'
import { setSearch } from '../presentationAttendeesSlice'
import AttendeeList from './AttendeeList'
import styles from '../../../constants/styles'
import formatJobInfo from '../../../utils/formatJobInfo'
import { useSubscribeToPresentationAttendees } from '../subscriptions'
import ShowMeToggle from '../../events/ShowMeToggle'

const S = {
    Sidebar: styled.div<{isShowSidebar: boolean}>`
        background: white;
        width: ${styles.sidebarWidth}px;
        height: 100%;
        position: fixed;
        right: ${({ isShowSidebar }) => (isShowSidebar ? 0 : -(styles.sidebarWidth))}px;
        transition: 0.75s;
        @media (max-width: 1366px) {
            width: ${styles.smallerSidebarWidth}px;
            right: ${({ isShowSidebar }) => (isShowSidebar ? 0 : -(styles.smallerSidebarWidth))}px;
        }
    `,
    SideBarTop: styled.div`
        background: ${colors.mineShaft};
        width: 100%;
        padding-top: 10px;
    `,
    UserWrapper: styled.div`
        display: flex;
        justify-content: space-between;
    `,
    UserInfo: styled.div`
        width: 270px;
        & .general-info-wrapper {
            background-color: transparent!important;
            & .general-info-name {
                color: white;
            }
        }
        @media (max-width: 1366px) {
            width: 200px;
        }
    `,
    ToggleWrapper: styled(Form.Group)`
        display: flex;
        flex-direction: column;
        margin-right: 10px;
        text-align: right;
        color: white;
    `,
    ToggleLabel: styled.div`
        font-size: 12px;
    `,
    Toggle: styled(FormCheck)`
        margin-left: auto;
        margin-top: 5px;
        transform: scale(1.6);
    `,
    InputGroup: styled.div`
        position: relative;
        padding: 8px 8px 10px 8px;
    `,
    SearchIcon: styled.div`
        position: absolute;
        top: 50%;
        right: 15px;
        transform: translateY(-53%);
    `,
    SideBarContent: styled.div`
        padding-left: 5px;
    `
}

const Sidebar = ({ isShowSidebar, isFullScreen }: {isShowSidebar: boolean, isFullScreen: boolean}) => {
    const dispatch = useDispatch()
    const presentationSlug = useSlug('presentationSlug')
    const currentUser = useSelector(currentUserSelector())

    const debounceSearch = useDebounce((value) => dispatch(setSearch(value)), 400)
    const handleSearch = (e) => {
        debounceSearch(e.target.value)
    }

    useSubscribeToPresentationAttendees(presentationSlug)

    return (
        <S.Sidebar isShowSidebar={isShowSidebar}>
            <S.SideBarTop>
                <S.UserWrapper>
                    <S.UserInfo>
                        <GeneralInfoWithThumbnail
                            name={`${currentUser.first_name} ${currentUser.last_name}`}
                            description={formatJobInfo(currentUser.jobtitle, currentUser.company)}
                            image={currentUser.mugshot}
                        />
                    </S.UserInfo>

                    <ShowMeToggle />
                </S.UserWrapper>

                <S.InputGroup>
                    <Form.Control
                        placeholder={_('networking.sidebar.search_placeholder')}
                        onChange={handleSearch}
                    />
                    <S.SearchIcon>
                        <StyledIcon icon="search" size={22} />
                    </S.SearchIcon>
                </S.InputGroup>
            </S.SideBarTop>

            <S.SideBarContent>
                {
                    isShowSidebar
                    && <AttendeeList hideActions isFullScreen={isFullScreen} />
                }
            </S.SideBarContent>
        </S.Sidebar>
    )
}

export default Sidebar
